import styled from 'styled-components';

export const InterstitielModalContainer = styled.div`
    .interstitiel-modal-header,
    .interstitiel-modal-status,
    .interstitiel-modal-metadata {
        min-height: 65px;
        width: 100%;
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/InterstitielModalComponentStyle.js